module.exports = __webpack_public_path__ + "img/stripe-payment-logo.d30aacb7.png";